/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Restoring_SessionInputs */



/**
* | output |
* | --- |
* | "Restoring your session…" |
*
* @param {Auth_Restoring_SessionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_restoring_session = /** @type {((inputs?: Auth_Restoring_SessionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Restoring_SessionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sitzung wird wiederhergestellt …")
	return /** @type {LocalizedString} */ ("Restoring your session…")
});